module.exports = __webpack_public_path__ + "img/33_26.52e857a6.png";